import { HoldingClass, Partner } from 'types';

export enum TradingOfferType {
  BUY = 'BUY', // eslint-disable-line no-unused-vars
  SELL = 'SELL', // eslint-disable-line no-unused-vars
}

export type TradingOfferStatus =
  | 'DRAFT'
  | 'PENDING'
  | 'ACTIVE'
  | 'ACCEPTED'
  | 'REJECTED'
  | 'EXPIRED'
  | 'CANCELED';

export type TradingOfferSharesCount = {
  total: number;
  agreed: number;
  approved: number;
};

/** Stored when the partner publishes an offer (server + client audit for contracts). */
export type TradingOfferPublisherAudit = {
  serverCapturedAt?: Date | string;
  clientIp?: string;
  forwardedFor?: string;
  requestUserAgent?: string;
  clientContext?: Record<string, unknown>;
};

export type TradingOffer = {
  _id: string;
  society: string;
  partner: string | Partial<Partner>;
  shareClass: string | Partial<HoldingClass> | null;
  emailSubsidiary?: string;
  documents: string[];
  sharesCount: TradingOfferSharesCount;
  sharePrice: number;
  startDate: Date | string;
  endDate: Date | string;
  type: TradingOfferType;
  isPartialAmountEnabled: boolean;
  isSellerNameHidden: boolean;
  createdAt: Date | string;
  updatedAt: Date | string;
  offerPublisherAudit?: TradingOfferPublisherAudit;
};

export type PartnerAgreedTradingOffer = {
  tradingOffer: string | TradingOffer;
  sharesCount: {
    agreed: number;
  };
  date: Date | string;
  isApproved: boolean;
  documents: string[];
};

export type TradingOffersCount = {
  buy: number;
  sell: number;
  total: number;
};

export type TradingOffersSummary = {
  offersCount: number;
  sharesCount: number;
  totalAmount: number;
};

export type TradingOfferPriceContext = {
  currentOfferPrice: number;
  lastTransactionPrice: number;
  avgSellOffersPrice: number;
  officialValuation: number;
  userAvgBuyPrice: number;
};

export type TradingOfferTimelineStep = {
  key: string;
  label: string;
  icon?: string;
  date?: string;
  isCompleted: boolean;
  isCurrent: boolean;
};

export type TradingOfferSellerInfo = {
  partnerId: string;
  name: string;
  image?: string;
  memberSince: string;
  totalShares: number;
  capitalPercentage: number;
  previousOperations: number;
  rating: number;
};
